import { ChangeLog, Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import {
  ProcessingRule,
  ProcessingRulesFormValues,
  PspAccount,
  PspIntegration,
  PspPartner,
} from '../types';

export const processingRulesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProcessingRules: build.query<Response<ProcessingRule>, string>({
      query: (query) => ({
        url: `/v1/transactions-rules${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getProcessingRule: build.query<{ data: ProcessingRule }, string>({
      query: (id) => ({
        url: `/v1/transactions-rules/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    addProcessingRule: build.mutation<
      {
        data: ProcessingRule;
      },
      ProcessingRulesFormValues
    >({
      query: (body) => ({
        url: '/v1/transactions-rules',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateProcessingRule: build.mutation<
      {
        data: ProcessingRule;
      },
      { id: string; body: ProcessingRulesFormValues }
    >({
      query: (data) => ({
        url: `/v1/transactions-rules/${data.id}`,
        method: 'PUT',
        body: {
          ...data.body,
          id: data.id,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getProcessingRulesPspPartners: build.query<Response<PspPartner>, void>({
      query: () => ({
        url: '/v1/psp-partners?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getProcessingRulesPspIntegrations: build.query<
      Response<PspIntegration>,
      void
    >({
      query: () => ({
        url: '/v1/psp-integrations',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getProcessingRulesChangeLogs: build.query<Response<ChangeLog>, string>({
      query: (query) => ({
        url: `/v1/audit-log${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getProcessingRulePspParnterAccounts: build.query<
      Response<PspAccount>,
      { id: string; query?: string }
    >({
      query: (data) => ({
        url: `/v1/psp-partners/${data.id}/primary-accounts${data.query || ''}${data?.query ? `&active=true` : '?active=true'}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPspAccountById: build.query<{ data: PspAccount }, string>({
      query: (id) => ({
        url: `/v1/psp-accounts/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetProcessingRulesQuery,
  useLazyGetProcessingRuleQuery,
  useAddProcessingRuleMutation,
  useUpdateProcessingRuleMutation,
  useLazyGetProcessingRulesPspPartnersQuery,
  useLazyGetProcessingRulesPspIntegrationsQuery,
  useLazyGetProcessingRulesChangeLogsQuery,
  useLazyGetProcessingRulePspParnterAccountsQuery,
  useLazyGetPspAccountByIdQuery,
} = processingRulesApi;

export const {
  endpoints: {
    getProcessingRules,
    getProcessingRule,
    addProcessingRule,
    updateProcessingRule,
    getProcessingRulesPspPartners,
    getProcessingRulesPspIntegrations,
    getProcessingRulesChangeLogs,
    getProcessingRulePspParnterAccounts,
    getPspAccountById,
  },
} = processingRulesApi;
